var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9534 66.5954L68.5532 55.3113C69.0277 54.4596 69.0277 53.4377 68.5532 52.6286L66.4827 49.0518L55.4399 67.958H59.6241C60.5731 67.958 61.4789 67.447 61.9534 66.5954Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0482 66.5949L73.6442 63.9122C74.1187 63.0606 74.1187 62.0386 73.6442 61.2296L71.5737 57.6953L65.5347 68.0001H69.7188C70.6247 67.9575 71.5305 67.4465 72.0482 66.5949Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4291 67.958L7.38634 49.0518L5.31583 52.6286C4.84134 53.4802 4.84134 54.5022 5.31583 55.3113L11.8725 66.5954C12.3469 67.447 13.2528 67.958 14.2449 67.958H18.4291Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42638 57.5249L0.35587 61.0592C-0.118623 61.9108 -0.118623 62.9328 0.35587 63.7418L1.99503 66.5948C2.46952 67.4464 3.37537 67.9574 4.36749 67.9574H8.55165L2.42638 57.5249Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.624 67.9575H49.5299C50.522 67.9575 51.4278 67.4466 51.9023 66.5949L63.5489 46.6667C64.0234 45.8151 64.0234 44.7931 63.5489 43.9841L61.4784 40.4072L46.9849 65.1472L48.624 67.9575Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4804 67.9577L14.0299 43.2178H10.7516L10.3202 44.0268C9.84573 44.8785 9.84573 45.9004 10.3202 46.7095L21.9669 66.5951C22.4414 67.4467 23.3472 67.9577 24.3393 67.9577H28.4804Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8279 61.4845L58.5019 38.1072C58.9764 37.2555 58.9764 36.2336 58.5019 35.4245L56.4314 31.8477L41.981 56.5876L44.8279 61.4845Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3428 43.2178L32.0168 66.5951C32.4913 67.4467 33.3971 67.9577 34.3893 67.9577H38.5734L24.0798 43.2178H18.3428Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1742 43.2178H28.394L42.0681 66.5951C42.5426 67.4467 43.4484 67.9577 44.4405 67.9577H48.6247L34.1742 43.2178Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5343 12.5166H30.3347C29.3426 12.5166 28.4799 13.0276 27.9623 13.8792L25.8486 17.4135H47.9773L45.9067 13.8366C45.3891 13.0276 44.4833 12.5166 43.5343 12.5166Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5738 4H35.2955C34.3034 4 33.4407 4.51098 32.9231 5.36261L30.8525 8.93947H43.0168L40.9463 5.36261C40.4718 4.51098 39.566 4 38.5738 4Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3855 23.2472L50.911 22.4808C50.4365 21.6291 49.5306 21.1182 48.5385 21.1182H25.2452C24.2531 21.1182 23.3904 21.6291 22.8728 22.4808L20.8022 26.0576H49.7463L51.3855 23.2472Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5903 29.7188H20.2423C19.2502 29.7188 18.3875 30.2297 17.8698 31.0814L15.7993 34.6582H44.7434L47.5903 29.7188Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8651 39.6409L10.7515 43.2178H39.6955L42.5856 38.2783H15.2376C14.2455 38.3209 13.3396 38.8319 12.8651 39.6409Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3855 23.2471L36.9351 47.987L39.8252 52.9265L53.4992 29.5492C53.9737 28.6975 53.9737 27.6756 53.4992 26.8665L51.3855 23.2471Z",
    fill: "url(#paint14_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 74.0918,
    y1: 53.0716,
    x2: 41.5632,
    y2: 69.9387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 77.4257,
    y1: 59.5189,
    x2: 45.0043,
    y2: 76.3295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.0388,
    y1: 68.4646,
    x2: 18.8631,
    y2: 26.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3.78809,
    y1: 67.2034,
    x2: 12.5156,
    y2: 25.2533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 70.7628,
    y1: 46.6402,
    x2: 38.2042,
    y2: 63.5246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 16.3967,
    y1: 69.768,
    x2: 25.2504,
    y2: 27.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 66.5909,
    y1: 38.5946,
    x2: 34.0279,
    y2: 55.4748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 25.0446,
    y1: 71.5428,
    x2: 33.8983,
    y2: 28.9788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 34.6878,
    y1: 73.5232,
    x2: 43.5415,
    y2: 30.9635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 23.2257,
    y1: 11.3644,
    x2: 60.4944,
    y2: 23.1614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 25.6819,
    y1: 3.60816,
    x2: 62.9506,
    y2: 15.4051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 20.7496,
    y1: 19.1919,
    x2: 58.0183,
    y2: 30.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 17.9867,
    y1: 27.9291,
    x2: 55.2511,
    y2: 39.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 15.0561,
    y1: 37.1806,
    x2: 52.3204,
    y2: 48.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 62.0063,
    y1: 29.7634,
    x2: 29.4476,
    y2: 46.6436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.55576bf0.svg";
export { ForwardRef as ReactComponent };